import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Link } from "react-router-dom";
import logo from "./logo.png";

class Navbar extends Component {
  render() {
    return (
      <>
        <nav className="navbar navbar-expand-sm bg-light navbar-light">
          <div className="container-fluid">
            <Link to={"/"}>
              <img
                src={logo}
                alt="Logo"
                className="navbar-brand"
                style={{ width: "100px", height: "auto" }}
              />
            </Link>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link to={"/about"} className="nav-link">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link to={"/contactUs"} className="nav-link">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </nav>
        <footer className="fixed-bottom bg-light text-dark py-1">
          <div className="container text-right">
            <p className="m-0" style={{ fontSize: "0.8rem" }}>
              &copy; 2024 Graph Algorithms Visualizer. All rights reserved.
            </p>
          </div>
        </footer>
      </>
    );
  }
}

export default Navbar;
